import { useWidget } from "../../../providers/widget"
import { ExploreWidgetConfig } from "../config"
import { useExplorer } from "../providers"
import { useFetchRecommendations } from "../data"
import PropertyCard from "./PropertyCard"

// Shown inside the no-results branch when the Recommendations feature is enabled.
// Renders a curated grid (featured / tag-scoped) so an empty search still has content.
export default function Recommendations() {
  const { options, feedId } = useWidget<ExploreWidgetConfig>()
  const { state } = useExplorer()
  const platformUuid = options.filter?.platform
  const enabled = options.features?.recommendations === true
  const rec = options.recommendations ?? { perPage: 4, showFeatured: true }

  // WP parity (#561): the tags source only applies when the featured source
  // is off — combining both would AND-filter (featured ∩ tags), which can
  // easily intersect to zero and hide recommendations entirely.
  const useFeatured = rec.showFeatured !== false
  const { data, isLoading } = useFetchRecommendations(
    feedId,
    { featured: useFeatured, tags: useFeatured ? undefined : rec.tags, limit: rec.perPage ?? 4, enabled },
    platformUuid,
  )

  if (!enabled) return null
  const properties = data?.result ?? []
  if (isLoading || properties.length === 0) return null

  return (
    <div className="hfse-recommendations">
      {rec.text && <div className="hfse-recommendations-heading hk-h4">{rec.text}</div>}
      <div
        className="hfse-properties"
        style={{
          '--hfse-grid-columns': options.grid.columns,
          '--hfse-grid-columns-780': options.grid.columns780,
          '--hfse-grid-columns-960': options.grid.columns960,
          '--hfse-grid-gap': `${options.grid.gap}px`,
        } as React.CSSProperties}
      >
        {properties.map((property) => (
          <PropertyCard
            key={property.id}
            property={property}
            options={options}
            visitorFilters={state.visitorFilters}
            showFavoriteButton={options.features?.favorites ?? false}
            mapActions={null}
          />
        ))}
      </div>
    </div>
  )
}
